<template>
<v-container fluid grid-list-lg class="ma-0 pa-0" id="analytics">
<v-layout row wrap>
<v-flex xs12 class="mb-1"><h1>Analytics</h1></v-flex>

<v-flex xs12 sm4>
<v-card class="elevation-4">
    <v-flex xs12 d-flex class="pb-0 mb-0">
        <v-select
          :items="analysis_types"
          v-model="analysis_type"
          label="Analysis Type"
          class="mt-2 pa-0"
          box
          dense
          hide-details
        ></v-select>
    </v-flex>

    <v-flex xs12 d-flex class="pt-0 pb-0">
        <v-select
          :items="collections"
          item-text="name"
          item-value="name"
          v-model="collection"
          label="Collection"
          class="mt-2 pa-0"
          box
          dense
          hide-details
          @change="getCollectionProperties"
        ></v-select>
    </v-flex>

    <v-flex v-if="collection && analysis_type !== 'count'" xs12 d-flex class="pt-0 pb-0">
        <v-select
          :items="collection_properties"
          v-model="target_property"
          label="Target Property"
          class="mt-2 pa-0"
          box
          dense
          hide-details
        ></v-select>
    </v-flex>

    <v-flex xs12 class="pl-0 pb-0 mt-2">
        Timeframe
    </v-flex>

    <v-flex xs12 class="pb-0">
    <v-btn-toggle mandatory v-model="timeframe" style="width:100%;">
        <v-btn block flat value="relative">
            Relative
        </v-btn>
        <v-btn block flat value="absolute">
            Absolute
        </v-btn>
    </v-btn-toggle>
    </v-flex>

    <v-flex xs12 v-if="timeframe === 'absolute'" class="pb-0">
        <v-datetime-picker
            label="Start"
            v-model="absolute_timeframe.start"
            :timezone="timezone"
            startOrEnd="start"
            fontSize="12px"
        />
        <v-datetime-picker
            label="End"
            v-model="absolute_timeframe.end"
            :timezone="timezone"
            startOrEnd="end"
            fontSize="12px"
        />
    </v-flex>

    <v-flex xs12 v-if="timeframe === 'relative'" class="pt-0">
        <v-layout row>
            <v-flex xs4>
                <v-select
                dense
                hide-details
                box
                single-line
                :items="['this', 'last']"
                v-model="relativity"
                label="Relativity"
                target="#analytics"
                class="mt-2 pa-0"
                ></v-select>
            </v-flex>
            <v-flex xs4>
                <v-text-field
                label="Amount"
                v-model="amount"
                class="mt-2"
                box
                hide-details
                single-line
                type="number"
                min="1"
                ></v-text-field>
            </v-flex>
            <v-flex xs4>
                <v-select
                dense
                box
                hide-details
                single-line
                :items="['minutes', 'hours', 'days', 'weeks', 'months', 'years']"
                v-model="sub_timeframe"
                label="Sub Timeframe"
                target="#analytics"
                class="mt-2 pa-0"
                ></v-select>
            </v-flex>
        </v-layout>
    </v-flex>

    <v-flex xs12 v-if="timeframe === 'relative'" style="font-size:10px;" class="text-xs-center pb-0 pt-1">
        The last {{amount}} {{sub_timeframe}} <b>{{relativity === 'this' ? 'including' : 'exluding'}}</b> the current {{sub_timeframe.slice(0, -1)}}.
    </v-flex>

    <v-flex xs12 class="pt-0">
        <v-select
        dense
        box
        hide-details
        :items="timezones"
        v-model="timezone"
        item-text="name"
        item-value="name"
        label="Timezone"
        class="mt-2 pa-0"
        ></v-select>
    </v-flex>

    <v-flex xs12 class="pb-0">
        <v-btn class="option-button" block @click="ui.groupby = !ui.groupby" :disabled="collection === null">GROUP BY</v-btn>
        <v-select
        v-if="ui.groupby"
        dense
        box
        hide-details
        single-line
        :items="collection_properties"
        v-model="groupBy"
        label="Group By"
        class="mt-2 pa-0"
        ></v-select>
    </v-flex>

    <v-flex xs12 class="pt-0 pb-0">
        <v-btn class="option-button" block @click="ui.filters = !ui.filters" :disabled="collection === null">FILTERS <span v-if="filters.length > 0" style="font-size:12px;">&nbsp;({{filters.length}})</span></v-btn>
    </v-flex>

    <v-flex xs12 class="pt-0">
        <v-btn class="option-button" block @click="ui.interval = !ui.interval" :disabled="collection === null">INTERVAL</v-btn>
        <v-select
        v-if="ui.interval"
        dense
        box
        hide-details
        single-line
        :items="['minutely', 'hourly', 'daily', 'weekly', 'monthly', 'yearly']"
        v-model="interval"
        label="Interval"
        class="mt-2 pa-0"
        ></v-select>
    </v-flex>
    <v-flex xs12 class="pt-0">
        <v-layout row wrap>
        <v-flex xs12 sm6><v-btn large style="border-radius:0px;" @click="clearQuery" block class="clear-button pb-0">clear</v-btn></v-flex>
        <v-flex xs12 sm6><v-btn large style="border-radius:0px;" @click="runQuery" block class="clear-button pt-0">run query</v-btn></v-flex>
        </v-layout>
    </v-flex>

    <v-progress-linear
        v-if="ui.loading"
        class="text-xs-center pa-0 mt-2"
        :color="isDark ? 'white' : 'primary'"
        indeterminate
    ></v-progress-linear>
</v-card>
</v-flex>

<v-flex xs12 sm8 class="pt-0">
    <v-flex xs12 v-if="query_result !== null" class="pb-0 pl-0">
        <v-layout row>
            <v-flex xs12>
                {{current_query}}
            </v-flex>
        </v-layout>
    </v-flex>

    <v-flex xs12 v-if="query_result !== null">
        <metric
        :card-color="chartColor.metric"
        :metric="query_result.result"
        height="350px"
        fontSize="6em"
        />
    </v-flex>
</v-flex>

<v-dialog
    v-model="ui.filters"
>
    <v-card>
    
    <v-toolbar>
    <v-toolbar-title>Filters</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon @click="ui.filters = false">
        <v-icon small>close</v-icon>
    </v-btn>
    </v-toolbar>

    <v-card-text>
        <v-flex xs12 v-for="(filter, i) in filters" :key="i">
            <v-layout row wrap>
            <v-flex xs12 sm4>
            <v-select
            dense
            box
            hide-details
            single-line
            :items="collection_properties"
            v-model="filters[i].property_name"
            label="Property Name"
            class="mt-2 pa-0"
            ></v-select>
            </v-flex>

            <v-flex xs12 sm2>
            <v-select
            dense
            box
            hide-details
            single-line
            :items="filter_operators"
            v-model="filters[i].operator"
            item-text="name"
            item-value="value"
            label="Operator"
            class="mt-2 pa-0"
            ></v-select>
            </v-flex>

            <v-flex xs12 sm2>
            <v-select
            label="Type"
            :items="filters[i].operator === null ? [] : filter_operators.find((filter) => filter.value === filters[i].operator).canBeCoeredTo"
            v-model="filters[i].property_type"
            class="mt-2"
            dense
            box
            hide-details
            single-line
            ></v-select>
            </v-flex>

            <v-flex xs12 sm3>
            <v-text-field
            v-if="filters[i].property_type !== 'Datetime' && filters[i].property_type !== 'Boolean'"
            label="Property Value"
            v-model="filters[i].property_value"
            :placeholder="filters[i].property_type"
            class="mt-2"
            box
            hide-details
            single-line
            ></v-text-field>

            <v-select
            v-if="filters[i].property_type === 'Boolean'"
            label="Property Value"
            :items="[true, false]"
            v-model="filters[i].property_value"
            class="mt-2"
            dense
            box
            hide-details
            single-line
            ></v-select>

            <v-datetime-picker
            v-if="filters[i].property_type === 'Datetime'"
            label="Datetime"
            v-model="filters[i].property_value"
            :timezone="timezone"
            startOrEnd="start"
            class="mt-2"
            fontSize="12px"
            />

            </v-flex>
            <v-flex xs12 sm1 class="mt-3 text-xs-center">
            
            <v-btn icon @click="removeFilter(i)">
                <v-icon large>remove</v-icon>
            </v-btn>
            </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12 class="pl-0 mt-4">
        <v-btn block @click="addFilter" class="ml-0 option-button">
            <v-icon>add</v-icon>
            ADD FILTER
        </v-btn>
        </v-flex>
    </v-card-text>
    </v-card>
</v-dialog>

</v-layout>
</v-container>
</template>
<script>
import KeenAnalysis from 'keen-analysis'
import keys from '@/components/keen/config'

export default {
    components: {
        'v-datetime-picker': () => import('@/components/DatetimePicker'),
        Metric: () => import('@/components/chart/Metric')
    },
    data () {
        return {
            ui: {
                loading: false,
                groupby: false,
                filters: false,
                interval: false
            },
            client: null,
            analysis_types: ['sum', 'count', 'count_unique', 'minimum', 'maximum', 'average', 'select_unique', 'extraction', 'percentage', 'median', 'funnel'],
            analysis_type: null,
            collections: null,
            collection: null,
            collection_properties: null,
            target_property: null,
            timeframe: 'relative',
            absolute_timeframe: {
                end: null,
                start: null
            },
            relativity: 'this',
            amount: 14,
            sub_timeframe: 'days',
            timezones: [{ name: 'UTC', offset: 0, dst_offset: 0 }, { name: 'Europe/London', offset: 0, dst_offset: 3600 }, { name: 'Africa/Casablanca', offset: 0, dst_offset: 0 }, { name: 'Africa/Nairobi', offset: 10800, dst_offset: 0 }, { name: 'Asia/Dubai', offset: 14400, dst_offset: 0 }, { name: 'America/Sao_Paulo', offset: -10800, dst_offset: -7200 }, { name: 'US/Eastern', offset: -18000, dst_offset: -14400 }, { name: 'US/Central', offset: -21600, dst_offset: -18000 }, { name: 'US/Mountain', offset: -25200, dst_offset: -21600 }, { name: 'US/Pacific', offset: -28800, dst_offset: -25200 }, { name: 'US/Alaska', offset: -32400, dst_offset: -28800 }, { name: 'US/Hawaii', offset: -36000, dst_offset: -32400 }, { name: 'Europe/Paris', offset: 3600, dst_offset: 7200 }, { name: 'Europe/Amsterdam', offset: 3600, dst_offset: 7200 }, { name: 'Europe/Stockholm', offset: 3600, dst_offset: 7200 }, { name: 'Europe/Prague', offset: 3600, dst_offset: 7200 }, { name: 'Asia/Istanbul', offset: 7200, dst_offset: 10800 }, { name: 'Europe/Istanbul', offset: 7200, dst_offset: 10800 }, { name: 'Europe/Copenhagen', offset: 3600, dst_offset: 7200 }, { name: 'Asia/Jakarta', offset: 25200, dst_offset: 25200 }, { name: 'Asia/Singapore', offset: 28800, dst_offset: 28800 }, { name: 'Australia/Perth', offset: 28800, dst_offset: 28800 }, { name: 'Asia/Tokyo', offset: 32400, dst_offset: 32400 }, { name: 'Australia/Sydney', offset: 36000, dst_offset: 39600 }, { name: 'Pacific/Auckland', offset: 43200, dst_offset: 46800 }],
            timezone: 'UTC',
            groupBy: null,
            filters: [],
            filter_operators: [ { name: '\u003D Equal to', value: 'eq', canBeCoeredTo: ['String', 'Number', 'Null', 'List', 'Boolean', 'Datetime'] }, { name: '\u2260 Not equal to', value: 'ne', canBeCoeredTo: ['String', 'Number', 'Null', 'List', 'Boolean', 'Datetime'] }, { name: '\u003E Greater than', value: 'gt', canBeCoeredTo: ['Number', 'Null', 'Datetime', 'String'] }, { name: '\u2265 Greater than or equal to', value: 'gte', canBeCoeredTo: ['Number', 'Null', 'Datetime', 'String'] }, { name: '\u003C Less than', value: 'lt', canBeCoeredTo: ['Number', 'Null', 'Datetime', 'String'] }, { name: '\u2264 Less than or equal to', value: 'lte', canBeCoeredTo: ['Number', 'Null', 'Datetime', 'String'] }, { name: '\u2203 Property exists', value: 'exists', canBeCoeredTo: ['Boolean'] }, { name: '\u229A String contains', value: 'contains', canBeCoeredTo: ['String', 'Null'] }, { name: '\u2349 String does not contain', value: 'not_contains', canBeCoeredTo: ['String', 'Null'] }, { name: '\u29C7 Matches any value in a list', value: 'in', canBeCoeredTo: ['List'] }, { name: '\u2690 Within a given radius (geo)', value: 'within', canBeCoeredTo: ['Geo'] } ],
            interval: null,
            result_types: ['metric'],
            result_type: null,
            query_result: null,
            current_query: null
        }
    },
    computed: {
        isAdmin () {
            return this.$store.getters.isAdmin !== null && this.$store.getters.isAdmin !== undefined
        },
        isManager () {
            return this.$store.getters.isManager !== null && this.$store.getters.isManager !== undefined
        },
        chartColor: function () {
            if(this.$vuetify.dark){
                return {card: '#40525b', chart: ['#0d2029'], metric: '#212121'}
            } else {
                return {card: '#FFFFFF', chart: ['#1976d2'], metric: '#1976d2'}
            }
        },
        isDark: function () {
            return this.$vuetify.dark
        }
    },
    methods: {
        getCollectionProperties: function () {
            var self = this
            var collection = self.collections.find((collection) => {
                return collection.name === self.collection
            })
            self.collection_properties = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(collection.properties))).sort()
        },
        addFilter: function () {
            var self = this
            self.filters.push({property_name: null, property_value: null, operator: null, property_type: null})
        },
        removeFilter: function (index) {
            var self = this
            self.filters.splice(index, 1)
        },
        clearQuery: function () {
            var self = this

            self.analysis_type = null
            self.target_property = null
            self.groupBy = null
            self.filters = []
            self.interval = null
            self.ui.groupby = false
            self.ui.interval = false
        },
        runQuery: function () {
            var self = this
            self.ui.loading = true

            var query = {
                analysis_type: self.analysis_type,
                event_collection: self.collection,
                timezone: self.timezone
            }

            if (self.analysis_type !== 'count') {
                query.target_property = self.target_property
            }

            if (self.timeframe === 'relative') {
                query.timeframe = self.relativity + '_' + self.amount + '_' + self.sub_timeframe
            } else {
                query.timeframe = self.absolute_timeframe
            }

            if (self.ui.groupby) {
                query.groupBy = self.groupBy
            }

            if (self.ui.interval) {
                query.interval = self.interval
            }

            if (self.filters.length > 0) {
                query.filters = []
                self.filters.forEach((filter) => {
                    query.filters.push({operator: filter.operator, property_name: filter.property_name, property_value: filter.property_value})
                })
            }

            console.log(query)

            self.client.query(query)
            .then((res) => {
                console.log(res)
                self.query_result = res

                if (self.analysis_type !== 'count') {
                    self.current_query = self.analysis_type + ' of ' + self.target_property + ' in ' + self.collection
                } else {
                    self.current_query = self.analysis_type + ' of ' + self.collection
                }

                self.ui.loading = false
            })
            .catch((err) => {
                console.error(err)
                self.ui.loading = false
            })
        }
    },
    created () {
        var self = this
        self.client = new KeenAnalysis({
            projectId: keys.keen.projectId,
            readKey: keys.keen.readKey
        })
        // Get all collections and their properties
        self.client.get(self.client.url('events'))
        .auth(self.client.readKey())
        .send()
        .then(collections => {
            self.collections = collections
        })
        .catch(err => {
            console.error(err)
        })
    },
    mounted () {

    }
}
</script>
<style lang="stylus" scoped>
.theme--dark-old .v-card
  background #40525B!important
.theme--dark-old .v-btn-toggle
  background #0d2029!important
.theme--dark-old .clear-button, .theme--dark-old .option-button
  background #0d2029!important
.v-input
  font-size 12px!important
</style>